import Crew from '../../services/crew'
import * as types from '../mutationTypes'

let state = {
  error: null,
  id: null,
  crews: [],
  users: null,
  crew: null,
  name: null,
  crewLeadId: null,
  taskListForCrew: [],
  headers: [
    { text: 'ID', value: 'id' },
    { text: 'Crew #', value: 'name' },
    { text: 'Crew Lead', value: 'crewLead.firstName' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  selectList (state) {
    return state.crews.map(crew => {
      return { text: (`${crew.crewLead.firstName} ${crew.crewLead.lastName}`), value: crew.id }
    })
  },
  taskListForCrew (state) {
    return state.taskListForCrew.map(crewTask => {
      return { text: (`WO ${crewTask.task.workOrder.workOrderNumber}-${crewTask.task.taskNumber}`), value: crewTask }
    })
  },
  crewsForTasks (state) {
    return state.crews.map(crew => {
      return { text: (`${crew.name}-${crew.crewLead.firstName}`), value: crew }
    })
  },

  selectCrewLeadAndCrew (state) {
    return state.crews.map(crew => {
      return ({ text: crew.crewLead.firstName, value: crew.id })
    })
  },

  id (state) {
    return state.id
  },
  crews (state) {
    return state.crews
  },
  headers () {
    return state.headers
  },
  error (state) {
    return state.error
  }
}

const actions = {
  async loadCrews ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Crew.get()
      if (res) {
        commit(types.REQUEST_GET_CREW_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CREW_ERROR, 'Error getting crews')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getTasksForCrew ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Crew.getCrewTasks(data)
      if (res) {
        commit(types.REQUEST_GET_CREW_TASKS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CREW_TASKS_ERROR, 'Can\'t find any tasks for crew id')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async createCrew ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Crew.create(data)
      if (res) {
        commit(types.REQUEST_CREATE_CREW_SUCCESS, res.data)
        dispatch('loadCrews')
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_CREW_ERROR, 'Error creating crew')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateCrew ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      const crew = { id: data.id, name: data.name, crewLeadId: data.crewLeadId, regionId: data.regionId }
      let res = await Crew.update(crew)
      if (res) {
        commit(types.REQUEST_UPDATE_CREW_SUCCESS, crew)
        dispatch('loadCrews')
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_CREW_ERROR, 'Error updating crew')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteCrew ({ commit, dispatch }, crew) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Crew.delete(crew.id)
      if (res) {
        commit(types.REQUEST_DELETE_CREW_SUCCESS, res.data)
        dispatch('loadCrews')
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_CREW_ERROR, `Error deleting crew ${err}`)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clear ({ commit }) {
    commit(types.CLEAR_CREW)
  }
}

const mutations = {
  [types.REQUEST_GET_CREW_SUCCESS] (state, data) {
    state.crews = data
    state.error = null
  },
  [types.REQUEST_GET_CREW_ERROR] (state, message) {
    state.error = message
    state.crews = []
  },
  [types.REQUEST_GET_CREW_TASKS_SUCCESS] (state, data) {
    state.taskListForCrew = data
    state.error = null
  },
  [types.REQUEST_GET_CREW_TASKS_ERROR] (state, message) {
    state.error = message
    state.taskListForCrew = []
  },
  [types.REQUEST_CREATE_CREW_SUCCESS] (state, data) {
    state.name = data.name
    state.crewLeadId = data.crewLeadId
    state.error = null
  },
  [types.REQUEST_CREATE_CREW_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_UPDATE_CREW_SUCCESS] (state, data) {
    state.name = data.name
    state.crewLeadId = data.crewLeadId
    state.error = null
  },
  [types.REQUEST_UPDATE_CREW_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_DELETE_CREW_SUCCESS] (state) {
    state.error = null
  },
  [types.REQUEST_DELETE_CREW_ERROR] (state, message) {
    if (message.includes('404')) {
      state.error = 'This crew may be assigned to a task.'
    } else {
      state.error = message
    }
  },
  [types.CLEAR_CREW] (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
